export default "__VITE_ASSET__BmQGwluC__"